var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBlueBoundary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.36,
    height: 11.802,
    viewBox: "0 0 13.36 11.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-.32 -3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hear_static",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Like",
    "data-name": "Icon / Like"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fill: "none",
    stroke: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 0a3.792 3.792 0 0 0-2.514 1.111l-.206.205-.206-.205a3.792 3.792 0 0 0-5.363 5.363l5.157 5.157a.583.583 0 0 0 .825 0l5.157-5.157A3.793 3.793 0 0 0 9.567 0z",
    transform: "translate(.32 .166)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ab2",
    d: "M9.578 1l-.144.003c-.695.033-1.349.323-1.842.816l-.206.205-.706.705-.706-.705-.207-.206C5.24 1.291 4.538 1 3.792 1c-.745 0-1.447.29-1.974.818-1.089 1.089-1.089 2.86 0 3.95l4.862 4.861 4.862-4.862c.528-.527.818-1.228.818-1.974s-.29-1.447-.818-1.975c-.525-.525-1.222-.815-1.964-.818m-.01-1c1.005 0 1.97.4 2.681 1.111.711.711 1.111 1.676 1.111 2.682s-.4 1.97-1.11 2.681l-5.158 5.157c-.114.114-.263.17-.412.17-.15 0-.299-.056-.413-.17L1.111 6.474c-1.481-1.48-1.481-3.882 0-5.363.74-.74 1.71-1.11 2.681-1.11.971 0 1.942.37 2.682 1.11l.206.205.206-.205C7.557.44 8.456.045 9.4.004L9.567 0z",
    transform: "translate(.32 .166)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlueBoundary);
export default __webpack_public_path__ + "static/media/heart-blue-boundary.4a632bb915b458449d8ff384acd9c9e1.svg";
export { ForwardRef as ReactComponent };